import React from "react";
import { AVI_ICONS } from "@/components/icons/AviIcons";

/** Logo du sous-type AVI (en-tête, état vide) — icône two-tone « maison », couleurs figées. */
export default function AviModuleLogo({ subtype, size = 42 }) {
  const Icon = AVI_ICONS[subtype] || AVI_ICONS.validation;
  return (
    <span className="shrink-0 inline-flex items-center justify-center" style={{ width: size, height: size }} data-testid={`avi-module-logo-${subtype}`}>
      <Icon size={size} />
    </span>
  );
}
